import React from "react";
import Portal from "../Portal/Portal";
import "./LessonNotAvailableModal.css";

interface LessonNotAvailableModalProps {
  title?: string;
  show: boolean;
  message: string;
}

const LessonNotAvailableModal: React.FC<LessonNotAvailableModalProps> = ({
  show,
  message,
  title = "Lesson Not Available",
}) => {
  if (!show) return null;

  return (
    <Portal>
      <div className="lesson-not-available-overlay">
        <div className="lesson-not-available-modal">
          <h2>{title}</h2>
          <p>{message}</p>
        </div>
      </div>
    </Portal>
  );
};

export default LessonNotAvailableModal;
